import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@env/environment';
import { NotificationService } from '@core/services/notification.service';


/**
 * @title Main Entry Point
 * @since 1.0.0
 * 
 * @description This is the main entry point of the Angular application. It bootstraps the root module
 * and initializes the application. The application is configured to use the `AppComponent` as the root
 * component. The `environment` variable is used to determine if the application is in production mode.
 */
bootstrapApplication(AppComponent, appConfig)
	.catch((err) => console.error(err));

/**
 * Service Worker Registration
 * @since 1.0.0
 *
 */

// If the browser supports service workers and the application is in production mode, register the service worker.
if ('serviceWorker' in navigator && environment.production) {
	// Register the service worker from the specified path.
	navigator.serviceWorker.register('/ngsw-worker.js').then(registration => {

		console.log('Service Worker registered with scope:', registration.scope);

		// Listen for updates to the service worker.
		registration.onupdatefound = () => {
			const installingWorker = registration.installing;
			if (installingWorker) {
				installingWorker.onstatechange = () => {
				if (installingWorker.state === 'installed') {
					if (navigator.serviceWorker.controller) {
						console.log('New content is available; please refresh.');
						const notificationService = new NotificationService();
						notificationService.showNotification('Client Quest Update verfügbar', {
							body: 'Bitte laden Sie die Seite neu, um die neueste Version zu erhalten.',
							icon: '/assetes/images/favicon-96x96.png'
						});
					} else {
						console.log('Content is cached for offline use.');
					}
				};
			}
			};
		};
	}).catch(error => {
		console.error('Service Worker registration failed:', error);
	});

}